<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="currencies.icon" class="mr-1"></i>
            <span>{{ currencies.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Currency" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="code" :debounce="currencies.debounce" placeholder="Currency"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!code" @click="code = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="currencies" :icon="currencies.icon"
            :busy="currencies.busy" :toolbarlibrary="currencies.toolbarlibrary" :tools="currencies.tools"
            :badges="currencies.badges" :fields="currencies.fields" :items="currencies.items" :limit="currencies.limit"
            :downloaded="currencies.downloaded" :showpages="true" :offset="currencies.offset" :page="currencies.page"
            @load="currencies_load" @click="currencies_click" @changed="currencies_click('save', $event)"
            @select="currencies_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="currencies.selected" :config="cconfig"
          @discard="currencies_click('discard')" @go="currencies_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import CurrencyEdit from "./Components/Setup_CurrencyEdit";

export default {
  name: "Currency",
  components: { CurrencyEdit },
  watch: {
    async code() {
      await this.currencies_load(0);
    },
  },
  data() {
    return {
      code: null,

      currencies: {
        title: "Currencies",
        icon: "fa fa-money",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "code",
            label: "Code",
            sortable: true,
          },
          {
            key: "description",
            label: "Name",
            sortable: true,
          },
          {
            key: "rate",
            label: "Ex Rate",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.currencies_load();
  },

  methods: {
    accessdenied() {
      this.currencies.denied = [];
      if (!this.user.permissions.includes("setup_currencies.admin")) {
        this.currencies.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_currencies.admin")) {
        this.currencies.denied.push("add");
        this.currencies.denied.push("save");
      }

    },

    async currencies_load(offset, limit, page) {
      let state = this.currencies;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        id: this.id,
        code: this.code,
        rate: this.rate,
        description: this.description,
        dateformat: "DD/MM/YYYY"
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_currencies(
                $limit: Int
                $offset: Int
                $id: String
                $code: String
                $description: String
                $rate: String         
                $dateformat: String                
              ) {
                setup_currencies(
                  limit: $limit
                  offset: $offset
                  id: $id
                  code: $code
                  description: $description
                  rate: $rate
                  dateformat: $dateformat
              
                ) {
                  id
                  code
                  description
                  rate                          
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
          variables,
        });
        // USE LOCAL VARIABLE

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_currencies
        } else {
          state.items = response.data.setup_currencies;
        }


      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async currencies_click(a, ss) {
      let state = this.currencies;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.currencies_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.currencies_load();
          break;
        case "go":
          this.component = null;
          await this.currencies_load();
          break;
        case "add":
        case "edit":
          this.component = "CurrencyEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async currencies_select(ss, tools) {

      let state = this.currencies;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_currencies_save(
                $rows: [setup_currencies_input]             
              ) {
                setup_currencies_save(rows: $rows, dateformat: $dateformat) {
                    id                    
                    code
                    description
                    rate
                    symbol
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_currencies_delete(
                $rows: [setup_currencies_input]
              ) {
                setup_currencies_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.currencies_load(0);
    },
  },
};
</script>

<style></style>